<script setup lang="ts">
import { useCategoryStore } from '@/store/category.store';
import { useQuery } from '@tanstack/vue-query';
import detailComponent from './detailComponent.vue';

import BodyProductSimPrev from './BodyProductSimPrev.vue';
import {
  ref,
  toRaw,
  shallowRef,
  useTemplateRef,
  watchEffect,
  computed,
  onMounted,
} from 'vue';
import { dataMenuHeaderNav } from '@/assets/svg/menuSimPrev';
import recomandationPrevSim from './recomandationPrevSim.vue';
import { stepTwoActive } from '@/refs/product.refs';
const categoryStore = useCategoryStore();

// -------------------------------
// 🔹 Récupération des catégories avec Vue Query
// -------------------------------
const {
  data: dataGetCategories,
  isLoading: isLoadingGetCategories,
  isError: isErrorGetCategories,
  refetch: refectGetCategories,
} = useQuery({
  queryKey: ['GetCategories'],
  queryFn: () => categoryStore.getCategory(),
});
</script>

<template>
  <div class="smoothScroll relative h-dvh w-full p-4 pt-15">
    <div class="flex w-full flex-row items-center justify-between px-5">
      <div class="LefticonMenu">
        <div
          class="relative right-[10px] flex items-center justify-center"
          v-html="dataMenuHeaderNav[0].link"
        />
      </div>

      <div class="flex h-[60px] w-[100px] items-center justify-center">
        <img
          src="https://hteteseqxjjlzcvmbfdq.supabase.co/storage/v1/object/public/store/chitir-chicken-logo.png"
          alt=""
          srcset=""
          class="h-full w-full object-contain"
        />
      </div>
      <div class="LefticonMenu">
        <div
          class="flex items-center justify-center"
          v-html="dataMenuHeaderNav[1].link"
        />
      </div>
    </div>

    <div class="flex flex-col">
      <div class="">
        <div class="px-5">
          <div
            class="relative right-[7px] aspect-square h-[140px] w-full bg-[url('https://hteteseqxjjlzcvmbfdq.supabase.co/storage/v1/object/public/local-test/62655039-0c78-41dd-9f1a-ea33ab548062/Cbd95Z4Bwr-rS0oHhoh5j.png')] bg-cover bg-no-repeat"
          ></div>
        </div>

        <div class="my-2">
          <div
            class="flex items-center justify-center"
            v-html="dataMenuHeaderNav[3].link"
          />
        </div>
        <div class="flex items-center gap-2 px-5">
          <div
            class="flex items-center justify-center"
            v-html="dataMenuHeaderNav[2].link"
          />
          <p
            class="text-grand-text font-tt-semiBold-Normal text-12px leading-normal text-ellipsis"
          >
            Suivre ma commande
          </p>
        </div>
      </div>
      <div class="my-1">
        <div
          class="flex items-center justify-center"
          v-html="dataMenuHeaderNav[3].link"
        />
      </div>
      <div class="">
        <recomandationPrevSim />
        <div class="my-block-header-y/100 !bg-soft-gray h-[2px] w-full" />
      </div>
    </div>

    <div class="my-4">
      <div
        class="flex items-center justify-center"
        v-html="dataMenuHeaderNav[3].link"
      />
    </div>
    <div
      class="flex w-[400px] flex-row items-center gap-2 overflow-hidden overflow-x-hidden px-5"
    >
      <div class="flex flex-col">
        <a class="text-12px font-tt-semiBold-Normal text-grand-text">
          {{ 'Combos' }}
        </a>

        <div>
          <svg
            width="66"
            height="3"
            viewBox="0 0 66 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="66" height="3" fill="#625353" />
          </svg>
        </div>
      </div>
      <a
        class="text-12px font-tt-medium-Normal text-secondary-text line-clamp-2"
        id="gotostart"
      >
        {{ 'Menus classics...' }}
      </a>
      <a
        class="text-12px font-tt-medium-Normal text-secondary-text line-clamp-2"
        id="gotostart"
      >
        {{ 'Desserts' }}
      </a>

      <a
        class="text-12px font-tt-medium-Normal text-secondary-text line-clamp-2"
        id="gotostart"
      >
        {{ 'Boisson' }}
      </a>
      <a
        class="text-12px font-tt-medium-Normal text-secondary-text line-clamp-2"
        id="gotostart"
      >
        {{ 'Burgers...' }}
      </a>
    </div>

    <div class="h-3" />
    <div class="w-[380px]">
      <BodyProductSimPrev />
    </div>

    <div
      class="absolute top-[35px] left-0 z-300 h-full w-full p-[19px]"
      v-show="stepTwoActive"
    >
      <div
        class="h-dvh w-[380px] rounded-tl-[25px] rounded-tr-[25px] rounded-br-[35px] rounded-bl-[35px] bg-white"
      >
        <detailComponent />
      </div>
    </div>
  </div>
</template>

<style scoped>
.active-link {
  color: #625353 !important;
  font-weight: 600;
  text-decoration: none;
  order: 2;
  border-bottom: 3px solid #625353;
  transition: all 0.3s ease-in-out;
}
</style>
